import { OBSIDIAN } from 'HubStyleTokens/colors';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import styled from 'styled-components';
import { getSearchRedirectUrl } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const EmptyStateText = styled.div.withConfig({
  displayName: "DropdownEmptyState__EmptyStateText",
  componentId: "sc-1chs6je-0"
})(["font-size:12px;color:", ";"], OBSIDIAN);
const DropdownEmptyState = () => {
  return /*#__PURE__*/_jsx("div", {
    className: "p-top-9 flex-column align-start",
    children: /*#__PURE__*/_jsx(EmptyStateText, {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "developer-docs-ui.search.resultsPopover.empty.redirect_jsx",
        elements: {
          Link: UILink
        },
        options: {
          linkProps: {
            href: getSearchRedirectUrl(''),
            external: true
          }
        }
      })
    })
  });
};
export default DropdownEmptyState;